/* eslint-disable react/no-array-index-key */
import React, { useMemo } from "react";
import { toggleLetterFocus } from "./utils";
import { useNoTranslateCells } from "./useNoTranslateCells";
import { Icon } from "../../components/tailwind";
import { ExcelFileViewerMode } from "./types";
const RenderCellLetter: React.FC<{
  cellNumber: number;
  noTranslateGetColumnInfo: ReturnType<
    ReturnType<typeof useNoTranslateCells>["getColumn"]
  >;
  mode: ExcelFileViewerMode;
  LanguageSelector?: React.FC<{
    cellNumber: number;
  }>;
}> = ({ cellNumber, noTranslateGetColumnInfo, mode, LanguageSelector }) => {
  const letter = String.fromCharCode(64 + cellNumber);
  const isLocked = useMemo(() => {
    return noTranslateGetColumnInfo?.info?.locked;
  }, [noTranslateGetColumnInfo]);

  const isEditable = mode === "edit";
  return (
    <td
      key={`${cellNumber}-${letter}`}
      className={`txu-excel-file-viewer-letter ${
        isLocked ? "tw-ring-1 tw-ring-red-500 tw-ring-inset" : ""
      }`}
      data-letter={cellNumber}
      tabIndex={-1}
      onFocus={(e) => {
        if (e.target.id.includes("dropdown-")) return; // prevent focus when interacting with dropdown
        toggleLetterFocus(cellNumber, true);
      }}
      onBlur={() => {
        toggleLetterFocus(cellNumber, false);
      }}
    >
      {isEditable ? (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-center">
          {LanguageSelector && (
            <div className="tw-flex-grow">
              <LanguageSelector cellNumber={cellNumber} />
            </div>
          )}
          <span className="tw-flex-1">{letter}</span>
          <Icon
            name={isLocked ? "lock_open" : "lock"}
            className="tw-text-base hover:tw-ring-1 hover:tw-ring-gray-300 tw-rounded-md tw-cursor-pointer"
            onClick={() => {
              if (isLocked) {
                noTranslateGetColumnInfo?.unmark();
              } else {
                noTranslateGetColumnInfo?.mark(true);
              }
            }}
          />
        </div>
      ) : (
        letter
      )}
    </td>
  );
};

export type Props = {
  numberOfCells: number;
  mode: ExcelFileViewerMode;
  noTranslateGetColumn: ReturnType<typeof useNoTranslateCells>["getColumn"];
  LanguageSelector?: React.FC<{
    cellNumber: number;
  }>;
};
export const LetterHeaderRowRender: React.FC<Props> = ({
  numberOfCells,
  noTranslateGetColumn,
  mode,
  LanguageSelector,
}) => {
  return (
    <tr className="tw-sticky -tw-top-4 tw-bg-white tw-z-10">
      <td></td>
      {Array.from({ length: numberOfCells }).map((_, idx) => (
        <RenderCellLetter
          key={idx}
          cellNumber={idx + 1}
          noTranslateGetColumnInfo={noTranslateGetColumn(idx + 1)}
          mode={mode}
          LanguageSelector={LanguageSelector}
        />
      ))}
    </tr>
  );
};
